window.MyraPwywMobileLuxe = ({ section, formats, config, selectFormat, setPrice }) => {
  if (!window.matchMedia('(max-width: 749px)').matches) return null;
  const phone = section.querySelector('.myra-phone');
  const picker = phone?.querySelector('.myra-picker');
  const template = section.querySelector('[data-mobile-luxe-template]');
  const scroll = phone?.querySelector('[data-phone-scroll]');
  const footer = phone?.querySelector('.myra-phone__checkout');
  const claim = phone?.querySelector('[data-phone-claim]');
  if (!picker || !template || !scroll || !footer || !claim) return null;
  const fragment = template.content.cloneNode(true);
  const copy = JSON.parse(fragment.querySelector('[data-luxe-copy]').textContent);
  const plainText = (value) => String(value ?? '').replace(
    /&(?:amp|lt|gt|quot|apos|#39|#x27|#\d+|#x[\da-f]+);/gi,
    (entity) => {
      const decoder = document.createElement('textarea');
      decoder.innerHTML = entity;
      return decoder.value;
    }
  );
  Object.keys(copy).forEach((key) => {
    if (typeof copy[key] === 'string') {
      copy[key] = plainText(copy[key]);
    }
  });
  Object.entries(copy.editor || {}).forEach(([key, value]) => {
    if (typeof value === 'string' && value.trim()) copy[key] = value.trim();
  });
  fragment.querySelector('[data-luxe-copy]').remove();
  const root = fragment.querySelector('.myra-luxe');
  root.querySelectorAll('[data-luxe-copy-setting]').forEach((node) => {
    const value = copy[node.dataset.luxeCopySetting];
    if (typeof value === 'string' && value.trim()) node.textContent = value;
  });
  const footerLabel = fragment.querySelector('[data-luxe-footer-label]');
  const footerTrust = fragment.querySelector('[data-luxe-footer-trust]');
  const start = root.querySelector('[data-luxe-start]');
  const purchase = root.querySelector('[data-luxe-purchase]');
  const priceField = root.querySelector('[data-luxe-price]');
  const priceError = picker.querySelector('[data-error]');
  priceError.classList.add('myra-luxe__purchase-error');
  const vaultPicker = root.querySelector('[data-luxe-vault-picker]');
  vaultPicker.style.cssText = root.querySelector('[data-luxe-treasury]').style.cssText;
  let screen = 'start';
  const touchedPrices = new Set();
  const originalClaimLabel = claim.getAttribute('aria-label');
  const input = picker.querySelector('[data-price]');
  const originalInputLabel = input.getAttribute('aria-label');
  const customHeading = picker.querySelector('.myra-picker__custom-heading strong');
  const customSubtitle = picker.querySelector('.myra-picker__custom-subtitle');
  const originalHeading = customHeading.textContent;
  const originalSubtitle = customSubtitle.textContent;
  const moves = [];
  const move = (node, destination) => {
    if (!node || !destination) return;
    const marker = document.createTextNode('');
    node.before(marker);
    destination.append(node);
    moves.push({ node, marker });
  };
  const iconPaths = {
    ebooks: '<path d="M12 5C9 2 5 2 2 3v16c3-1 7-1 10 2 3-3 7-3 10-2V3c-3-1-7-1-10 2Zm0 0v16"/>',
    audio: '<path d="M3 14V11a9 9 0 0 1 18 0v3M3 12h3v9H3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2Zm18 0h-3v9h3a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2Z"/>',
    bundle: '<path d="m2 6 5 5 5-9 5 9 5-5-3 13H5L2 6Zm3 16h14"/>'
  };
  const icon = (kind) => `<svg viewBox="0 0 24 24" aria-hidden="true">${iconPaths[kind] || iconPaths.ebooks}</svg>`;
  const cards = new Map();
  formats.forEach((format) => {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = `myra-luxe__card myra-luxe__card--${format.kind}`;
    card.dataset.luxeFormat = format.id;
    const symbol = document.createElement('span');
    symbol.className = 'myra-luxe__card-icon';
    symbol.innerHTML = icon(format.kind);
    const words = document.createElement('span');
    words.className = 'myra-luxe__card-words';
    const title = document.createElement('strong');
    title.textContent = copy[format.kind] || format.label;
    words.append(title);
    if (format.kind === 'bundle' && (copy.bestValue || config.bestValueBadge)) {
      const badge = document.createElement('b');
      badge.className = 'myra-luxe__badge';
      badge.textContent = copy.bestValue || config.bestValueBadge;
      words.append(badge);
    }
    const description = document.createElement('small');
    description.textContent = copy[`${format.kind}Copy`] || format.shortTitle || '';
    words.append(description);
    const arrow = document.createElement('span');
    arrow.className = 'myra-luxe__card-arrow';
    arrow.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7 4 6 6-6 6"/></svg>';
    card.append(symbol, words, arrow);
    card.addEventListener('click', () => {
      reviewed = false;
      selectFormat(format.id);
      navigate('purchase');
    });
    root.querySelector('[data-luxe-formats]').append(card);
    cards.set(format.id, card);
  });
  picker.append(root);
  footer.prepend(footerLabel);
  footer.append(footerTrust);
  move(priceError, root.querySelector('[data-luxe-price-error]'));
  move(picker.querySelector('.myra-picker__summary'), root.querySelector('[data-luxe-summary]'));
  move(picker.querySelector('[data-vault]'), root.querySelector('[data-luxe-vault]'));
  move(picker.querySelector('.myra-picker__anchors'), root.querySelector('[data-luxe-presets]'));
  const presetAnchors = root.querySelector('[data-luxe-presets] .myra-picker__anchors');
  let createdCollector = null;
  if (!presetAnchors.querySelector('[data-tier="minimum"]')) {
    createdCollector = document.createElement('button');
    createdCollector.type = 'button';
    createdCollector.className = 'myra-picker__tier';
    createdCollector.dataset.tier = 'minimum';
    presetAnchors.prepend(createdCollector);
  }
  const presetOriginals = [];
  for (const tier of ['minimum', 'suggested', 'unlock']) {
    const button = presetAnchors.querySelector(`[data-tier="${tier}"]`);
    if (button !== createdCollector) presetOriginals.push({ button, children: [...button.childNodes] });
    const label = document.createElement('span');
    label.className = 'myra-picker__tier-label';
    const amount = document.createElement('strong');
    amount.setAttribute(`data-${tier}`, '');
    const description = document.createElement('small');
    description.className = 'myra-picker__tier-copy';
    button.replaceChildren(label, amount, description);
  }
  const suggestedButton = root.querySelector('[data-luxe-presets] [data-tier="suggested"]');
  const suggestedBadge = document.createElement('b');
  suggestedBadge.className = 'myra-luxe__tier-tag';
  suggestedBadge.textContent = copy.pickNote;
  suggestedButton?.append(suggestedBadge);
  const ultimateButton = root.querySelector('[data-luxe-presets] [data-tier="unlock"]');
  const ultimateBadge = document.createElement('b');
  ultimateBadge.className = 'myra-luxe__ultimate-badge';
  ultimateBadge.textContent = copy.unlockEverything;
  ultimateButton?.append(ultimateBadge);
  const upgradeCopy = document.createElement('small');
  upgradeCopy.className = 'myra-luxe__upgrade-copy';
  root.querySelector('[data-luxe-upgrade-note]').append(upgradeCopy);
  move(picker.querySelector('.myra-picker__custom-wrap'), root.querySelector('[data-luxe-custom]'));
  move(picker.querySelector('.myra-picker__microcopy'), root.querySelector('[data-luxe-reassurance]'));
  const timer = picker.querySelector('.myra-picker__timer');
  if (timer) {
    move(timer, phone.querySelector('.myra-phone__screen'));
    scroll.before(timer);
  }
  customHeading.textContent = copy.choosePrice;
  customSubtitle.textContent = copy.priceHint;
  input.setAttribute('aria-label', copy.choosePrice);
  section.dataset.mobileLuxe = 'true';
  let reviewed = false;
  let latest = null;
  let checkoutAction = null;
  const feedback = (() => {
    const settings = copy.feedbackSettings || {};
    ['feedbackSaving', 'feedbackTip'].forEach((key) => {
      if (typeof settings[key] === 'string' && settings[key].trim()) {
        copy[key] = plainText(settings[key].trim());
      }
    });
    const settingNumber = (key, fallback, min, max) =>
      Math.min(max, Math.max(min, Number(settings[key]) || fallback));
    const duration = settingNumber('duration', 2.8, 1.8, 4) * 1000;
    const numberDuration = settingNumber('number_duration', 750, 600, 900);
    const inputDelay = settingNumber('input_delay', 600, 300, 1000);
    const toast = document.createElement('div');
    toast.className = 'myra-luxe__feedback';
    toast.style.setProperty('--feedback-title-size', `${settingNumber('title_size', 12, 9, 18)}px`);
    toast.dataset.state = 'hidden';
    toast.setAttribute('aria-hidden', 'true');
    const heading = document.createElement('strong');
    heading.className = 'myra-luxe__feedback-title';
    const glitter = document.createElement('span');
    glitter.className = 'myra-luxe__feedback-glitter';
    [[8, 65, -4, -12], [20, 24, 3, -10], [34, 78, -3, -14],
      [47, 18, 4, -9], [61, 74, 3, -12], [73, 26, -4, -10],
      [86, 67, 4, -14], [94, 30, -3, -9]].forEach(([x, y, dx, dy], index) => {
      const particle = document.createElement('i');
      particle.style.cssText = `left:${x}%;top:${y}%;--dx:${dx}px;--dy:${dy}px;--delay:${index * 45}ms`;
      glitter.append(particle);
    });
    toast.append(heading, glitter);
    const announcement = document.createElement('span');
    announcement.className = 'myra-luxe__feedback-announcement';
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    footer.append(toast, announcement);
    if (settings.enabled !== false) {
      root.querySelector('[data-luxe-treasury-status]').removeAttribute('aria-live');
    }
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let baseline = null;
    let current = null;
    let pending = null;
    let commitTimer = 0;
    let frame = 0;
    let phases = [];
    let displayed = null;
    let destroyed = false;
    const active = () => settings.enabled !== false && !destroyed && screen === 'purchase' &&
      !phone.classList.contains('is-sample-mode') && root.isConnected;
    const snapshot = (data) => {
      if (!data) return null;
      const { format, price, money, rewards } = data;
      const valid = !data.invalidPrice && !data.checkingOut && Number.isFinite(price);
      const amounts = rewards.map((reward) => Number(reward.amount)).filter(Number.isFinite);
      const treasuryPrice = Math.max(Number(format.unlock), ...amounts);
      const retail = Number(format.retail);
      const priceCents = Math.round(price * 100);
      const marketRatio = Number(format.informationalMarketRatio || 1);
      const countedRewards = new Set();

      const treasuryValueCents = rewards.reduce((total, reward) => {
        const threshold = Number(reward.amount);
        const value = Number(reward.toastValue);
        const key = reward.variantId || reward.id;

        if (!valid || data.booksOnly ||
            priceCents < Math.round(Number(format.minimum) * 100) ||
            !Number.isFinite(threshold) ||
            priceCents < Math.round(threshold * 100) ||
            !Number.isFinite(value) || value <= 0 ||
            !Number.isFinite(marketRatio) || marketRatio <= 0 ||
            countedRewards.has(key)) return total;

        countedRewards.add(key);
        return total + Math.round(value * marketRatio * 100);
      }, 0);

      const saving = Number.isFinite(retail) && retail > 0
        ? Math.max(
            0,
            Math.round(retail * 100) + treasuryValueCents - priceCents
          ) / 100
        : 0;
      const tip = Number.isFinite(treasuryPrice) && treasuryPrice > 0
        ? Math.max(0, Math.round((price - treasuryPrice) * 100) / 100) : 0;
      return { format, price, money, valid, saving, tip,
        signature: JSON.stringify([format.id, Math.round(price * 100)]) };
    };
    const hide = () => {
      phases.forEach((timer) => window.clearTimeout(timer));
      phases = [];
      window.cancelAnimationFrame(frame);
      frame = 0;
      toast.dataset.state = 'hidden';
      announcement.textContent = '';
    };
    const reset = (data) => {
      window.clearTimeout(commitTimer);
      pending = null;
      current = snapshot(data);
      baseline = current?.valid ? current : null;
      displayed = null;
      hide();
    };
    const show = (kind, amount, state) => {
      hide();
      if (!active()) return;
      const message = kind === 'tip' ? copy.feedbackTip : copy.feedbackSaving;
      const formatAmount = (value) => message.replaceAll('[amount]', state.money(value));
      const from = displayed?.kind === kind && displayed.amount <= amount ? displayed.amount : 0;
      heading.textContent = formatAmount(motion.matches ? amount : from);
      announcement.textContent = formatAmount(amount);
      toast.dataset.state = 'entering';
      void toast.offsetWidth;
      frame = window.requestAnimationFrame(() => {
        if (!active()) { hide(); return; }
        toast.dataset.state = 'celebrating';
        if (motion.matches) {
          displayed = { kind, amount };
          frame = 0;
          return;
        }
        const started = performance.now();
        const count = (now) => {
          if (!active()) { hide(); return; }
          const progress = Math.min(1, (now - started) / numberDuration);
          const value = from + (amount - from) * (1 - Math.pow(1 - progress, 3));
          displayed = { kind, amount: value };
          heading.textContent = formatAmount(value);
          if (progress < 1) frame = window.requestAnimationFrame(count);
          else { displayed = { kind, amount }; frame = 0; }
        };
        frame = window.requestAnimationFrame(count);
      });
      phases.push(window.setTimeout(() => { toast.dataset.state = 'settling'; }, 1050));
      phases.push(window.setTimeout(() => { toast.dataset.state = 'leaving'; }, duration - 230));
      phases.push(window.setTimeout(hide, duration));
    };
    const flush = () => {
      window.clearTimeout(commitTimer);
      if (!pending) return;
      const { before, mode } = pending;
      pending = null;
      if (!active() || !current?.valid) { hide(); return; }
      const after = current;
      baseline = after;
      if (!before?.valid || before.format.id !== after.format.id || before.signature === after.signature) return;
      if (mode === 'custom' && after.tip > 0) show('tip', after.tip, after);
      else if (settings.show_savings !== false && after.saving > 0) show('saving', after.saving, after);
    };
    const observer = new MutationObserver(() => {
      if (phone.classList.contains('is-sample-mode')) reset(latest);
    });
    observer.observe(phone, { attributes: true, attributeFilter: ['class'] });
    return {
      begin(mode) {
        if (!active() || !latest || latest.checkingOut) return;
        const before = pending?.before || baseline || snapshot(latest);
        window.clearTimeout(commitTimer);
        pending = { mode, before, schedule: true };
        hide();
      },
      update(data) {
        const next = snapshot(data);
        if (!active() || (current && current.format.id !== next.format.id) || data.checkingOut) {
          reset(data);
          return;
        }
        current = next;
        if (!next.valid) { window.clearTimeout(commitTimer); hide(); return; }
        if (!pending) { baseline = next; return; }
        if (pending.mode === 'custom') {
          if (pending.schedule) {
            pending.schedule = false;
            commitTimer = window.setTimeout(flush, inputDelay);
          }
        } else flush();
      },
      flush,
      reset,
      destroy() {
        destroyed = true;
        reset(null);
        observer.disconnect();
        toast.remove();
        announcement.remove();
      }
    };
  })();
  const scrollTo = (target) => {
    const offset = target.getBoundingClientRect().top - scroll.getBoundingClientRect().top + scroll.scrollTop;
    scroll.scrollTo({ top: Math.max(0, offset - 8), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  const openTiers = new Set();
  const notifySize = (expanded) => {
    root.dispatchEvent(new CustomEvent('myra:pwyw:phone-content-resized', {
      bubbles: true, detail: { expanded }
    }));
  };
  const navigate = (destination) => {
    screen = destination;
    feedback.reset(latest);
    start.hidden = screen !== 'start';
    purchase.hidden = screen !== 'purchase';
    phone.dataset.luxeScreen = screen;
    scroll.scrollTo({ top: 0, behavior: 'instant' });
    if (latest) updatePurchase(latest);
    paintFooter();
    window.requestAnimationFrame(() => {
      if (!root.isConnected) return;
      const focusTarget = screen === 'purchase'
        ? root.querySelector('[data-luxe-page-title]')
        : cards.get(latest?.format.id);
      focusTarget?.focus({ preventScroll: true });
      notifySize(true);
    });
  };
  const paintFooter = () => {
    if (!latest) return;
    const { invalidPrice, checkingOut } = latest;
    const blocked = invalidPrice || checkingOut || screen !== 'purchase';
    claim.disabled = blocked;
    claim.setAttribute('aria-disabled', String(blocked));
    claim.onclick = () => {
      if (screen === 'purchase' && !latest.invalidPrice && !latest.checkingOut) {
        checkoutAction?.();
      }
    };
  };
  const titleForReward = (reward) => reward.mobileTitle?.trim() || reward.name;
  const paintPresetOptions = (data) => {
    const { format, money } = data;
    const defaultTitles = [copy.collectorTitle, copy.suggestedTitle, copy.ultimateTitle];
    const defaultDescriptions = [copy.collectorCopy, copy.pickNote, copy.ultimateNote];
    ['minimum', 'suggested', 'unlock'].forEach((tier, index) => {
      const button = presetAnchors.querySelector(`[data-tier="${tier}"]`);
      const title = format.mobileTierTitles?.[index]?.trim() ||
        defaultTitles[index].replace('[format]', format.label);
      button.querySelector('.myra-picker__tier-label').textContent = title;
      button.querySelector('strong').textContent = money(Number(format[tier]));
      button.querySelector('.myra-picker__tier-copy').textContent =
        format.mobileTierCopies?.[index]?.trim() || defaultDescriptions[index];
    });
    const minimumNote = root.querySelector('[data-luxe-minimum]');
    minimumNote.hidden = true;
    minimumNote.textContent = '';
  };
  const updatePurchase = (data) => {
    const { format, price, invalidPrice, inputInvalid, booksOnly, minimum, money, rewards } = data;
    const hero = root.querySelector('[data-luxe-hero]');
    const source = format.mobilePageHero || format.mobileImage || format.image;
    hero.hidden = !source;
    if (source && hero.getAttribute('src') !== source) hero.src = source;
    hero.alt = format.imageAlt || format.mobilePageTitle || format.title;
    root.querySelector('[data-luxe-page-title]').textContent = format.mobilePageTitle?.trim() || format.label;
    root.querySelector('[data-luxe-page-count]').textContent = format.mobilePageSubtitle?.trim() || format.shortTitle || format.title;
    purchase.style.setProperty('--luxe-page-title-size', `${Number(format.mobilePageTitleSize) || 32}px`);
    purchase.style.setProperty('--luxe-page-subtitle-size', `${Number(format.mobilePageSubtitleSize) || 12}px`);
    const blurb = root.querySelector('[data-luxe-page-copy]');
    blurb.textContent = format.mobilePageCopy?.trim() || format.salesBlurb || '';
    blurb.hidden = !blurb.textContent;
    const retail = root.querySelector('[data-luxe-retail]');
    retail.hidden = !Number.isFinite(Number(format.retail)) || Number(format.retail) <= 0;
    retail.textContent = retail.hidden ? '' : copy.retail.replace('[amount]', money(format.retail));
    root.querySelector('[data-luxe-currency]').textContent = picker.querySelector('[data-currency-symbol]')?.textContent || config.currencySymbol || '';
    const usingCustomPrice = touchedPrices.has(format.id);
    if (document.activeElement !== priceField) {
      priceField.value = usingCustomPrice && Number.isFinite(price) ? price.toFixed(2) : '0.00';
    }
    const qualifyingTier = !invalidPrice && !booksOnly
      ? ['unlock', 'suggested', 'minimum'].find((tier) =>
          Math.round(Number(price) * 100) >= Math.round(Number(format[tier]) * 100)
        )
      : null;
    root.querySelectorAll('[data-luxe-presets] [data-tier]').forEach((button) => {
      const selected = button.dataset.tier === qualifyingTier;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    root.querySelector('.myra-luxe__original-price').classList.toggle('is-custom-active', usingCustomPrice);
    const upgradeDifference = Number(format.unlock) - Number(price);
    upgradeCopy.hidden = invalidPrice || !Number.isFinite(upgradeDifference) || upgradeDifference <= 0;
    upgradeCopy.textContent = upgradeCopy.hidden ? ''
      : copy.upgrade.replace('[amount]', money(upgradeDifference));
    priceField.setAttribute('aria-invalid', String(invalidPrice && touchedPrices.has(format.id)));
    root.querySelector('[data-luxe-minimum]').textContent = copy.minimum.replace('[minimum]', money(minimum));
    let error = '';
    if (invalidPrice && touchedPrices.has(format.id)) {
      error = inputInvalid ? config.priceError
        : price < minimum ? config.minimumError.replace('[minimum]', money(minimum))
        : price > Number(format.maximum) ? config.maximumError.replace('[maximum]', money(format.maximum))
        : config.priceError;
    }
    priceError.textContent = error;
    priceError.hidden = !error;
    const inclusion = root.querySelector('[data-luxe-books-only]');
    inclusion.hidden = !booksOnly;
    inclusion.textContent = booksOnly
      ? format.booksOnlyCopy?.trim() || copy.booksOnly.replace('[format]', format.shortTitle || format.label)
      : '';
    const vaultAmount = Math.max(
      Number(format.unlock),
      ...rewards.map((reward) => Number(reward.amount))
    );
    const complete = !invalidPrice && !booksOnly && price >= vaultAmount;
    const items = [
      {
        title: [format.shortTitle || format.title,
          format.kind === 'ebooks' ? '' : copy.treasuryAudioNote].filter(Boolean).join(' · '),
        included: !invalidPrice
      },
      ...rewards.map((reward) => ({
        title: titleForReward(reward),
        included: !invalidPrice && !booksOnly && price >= Number(reward.amount)
      }))
    ];
    const checklist = root.querySelector('[data-luxe-treasury-checklist]');
    checklist.replaceChildren(...items.map((item) => {
      const row = document.createElement('li');
      row.className = 'myra-luxe__treasury-item';
      row.classList.toggle('is-included', item.included);
      const mark = document.createElement('span');
      mark.className = 'myra-luxe__treasury-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = invalidPrice ? '–' : item.included ? '✓' : '+';
      const words = document.createElement('span');
      words.textContent = plainText(item.title);
      const state = document.createElement('small');
      state.textContent = item.included ? copy.treasuryIncluded : copy.treasuryLocked;
      state.hidden = invalidPrice;
      words.append(state);
      row.append(mark, words);
      return row;
    }));
    const artwork = [...vaultPicker.querySelectorAll('[data-luxe-treasury-art]')];
    artwork.forEach((image) => {
      image.hidden = image.dataset.luxeTreasuryArt !== format.kind;
    });
    vaultPicker.classList.toggle('has-art', artwork.some((image) => !image.hidden));
    vaultPicker.hidden = rewards.length === 0;
    const status = root.querySelector('[data-luxe-treasury-status]');
    status.hidden = !complete;
    status.textContent = complete ? copy.treasuryComplete : '';
    const upgradeButton = root.querySelector('[data-luxe-treasury-upgrade]');
    const validTarget = Number.isFinite(vaultAmount) &&
      vaultAmount >= Number(minimum) && vaultAmount <= Number(format.maximum);
    const difference = Math.round((vaultAmount - Number(price)) * 100) / 100;
    upgradeButton.hidden = complete || invalidPrice || !validTarget || rewards.length === 0;
    upgradeButton.disabled = upgradeButton.hidden || data.checkingOut || screen !== 'purchase';
    upgradeButton.dataset.amount = String(vaultAmount);
    upgradeButton.textContent = upgradeButton.hidden ? ''
      : copy.treasuryUpgrade.replace('[amount]', money(difference));
    paintPresetOptions(data);
  };
  phone.dataset.luxeScreen = 'start';
  root.querySelector('[data-luxe-back]').addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    navigate('start');
  });
  root.querySelector('[data-luxe-price-shortcut]').addEventListener('click', () => {
    if (screen !== 'purchase' || latest?.checkingOut) return;
    priceField.focus({ preventScroll: true });
    scrollTo(priceField.closest('.myra-luxe__purchase-custom'));
  });
  const offerDetails = root.querySelector('[data-luxe-offer-details]');
  offerDetails.addEventListener('toggle', () => {
    if (screen === 'purchase') notifySize(offerDetails.open);
  });
  const treasuryUpgrade = root.querySelector('[data-luxe-treasury-upgrade]');
  treasuryUpgrade.addEventListener('click', () => {
    if (!latest || latest.invalidPrice || latest.checkingOut ||
        screen !== 'purchase' || treasuryUpgrade.hidden || treasuryUpgrade.disabled) return;
    const amount = Number(treasuryUpgrade.dataset.amount);
    if (!Number.isFinite(amount)) return;
    feedback.begin('preset');
    touchedPrices.delete(latest.format.id);
    setPrice(amount.toFixed(2));
    notifySize(true);
  });
  vaultPicker.querySelectorAll('img').forEach((image) => {
    image.addEventListener('load', () => {
      if (screen === 'purchase') notifySize(true);
    });
  });
  root.querySelector('[data-luxe-hero]').addEventListener('load', () => {
    if (screen === 'purchase') notifySize(true);
  });
  root.addEventListener('click', (event) => {
    const tierButton = event.target.closest('[data-luxe-presets] [data-tier]');
    if (tierButton && latest && !tierButton.disabled) {
      feedback.begin('preset');
      touchedPrices.delete(latest.format.id);
    }
  }, true);
  priceField.addEventListener('focus', () => {
    if (latest && !touchedPrices.has(latest.format.id) && priceField.value === '0.00') {
      priceField.value = '';
      return;
    }
    const valueAtFocus = priceField.value;
    window.requestAnimationFrame(() => {
      if (document.activeElement === priceField && priceField.value === valueAtFocus) {
        priceField.select();
      }
    });
  });
  priceField.addEventListener('input', () => {
    if (!latest) return;
    feedback.begin('custom');
    touchedPrices.add(latest.format.id);
    setPrice(priceField.value);
  });
  priceField.addEventListener('blur', (event) => {
    if (latest) updatePurchase(latest);
    if (!event.relatedTarget?.closest('[data-tier], [data-luxe-treasury-upgrade], [data-luxe-back]')) feedback.flush();
  });
  priceField.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') { event.preventDefault(); priceField.blur(); }
  });
  root.querySelector('[data-luxe-see-tiers]').addEventListener('click', () => scrollTo(root.querySelector('[data-luxe-treasury]')));
  return {
    update(data) {
      latest = data;
      checkoutAction = claim.onclick;
      const { format, price, invalidPrice, giftActive, timerExpired, money } = data;
      cards.forEach((card, id) => {
        const selected = id === format.id;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-pressed', String(selected));
      });
      const formatLabel = format.shortTitle || format.title;
      root.querySelector('[data-luxe-format-note]').textContent = copy.formatNote.replace('[format]', formatLabel);
      const mobileSource = picker.querySelector('[data-art-mobile]');
      if (format.image) mobileSource.srcset = format.image;
      const saving = Number(format.retail) - Number(price);
      const savingsNode = root.querySelector('[data-luxe-saving]');
      savingsNode.hidden = invalidPrice || !Number.isFinite(saving) || saving <= 0;
      savingsNode.textContent = savingsNode.hidden ? '' : copy.saving.replace('[amount]', money(saving));
      const gift = root.querySelector('[data-luxe-gift]');
      gift.hidden = !giftActive && !timerExpired;
      gift.textContent = giftActive ? copy.gift : timerExpired ? copy.giftExpired : '';
      root.querySelector('[data-luxe-range]').textContent = copy.priceRange.replace('[minimum]', money(format.minimum)).replace('[maximum]', money(format.maximum));
      picker.querySelectorAll('.myra-picker__reward-card').forEach((card) => {
        const reward = config.rewards.find((item) => item.id === card.dataset.rewardId);
        const body = card.querySelector('.myra-picker__reward-body');
        const originalTitle = body.querySelector('h3')?.textContent || reward?.name || '';
        const title = reward?.mobileTitle?.trim() || originalTitle;
        const description = body.querySelector('.myra-picker__reward-description') || document.createElement('p');
        description.className = 'myra-picker__reward-description';
        if (reward?.mobileDetails?.trim()) description.textContent = reward.mobileDetails;
        const key = `${format.id}:${card.dataset.rewardId}`;
        card.onclick = null;
        card.onkeydown = null;
        card.removeAttribute('role');
        card.removeAttribute('tabindex');
        card.removeAttribute('aria-label');
        card.classList.remove('is-clickable', 'is-locked', 'is-unlocked', 'is-blurred');
        card.querySelectorAll('.myra-picker__reward-state-icon').forEach((node) => node.remove());
        const previewSource = reward?.mobileImage || card.querySelector('.myra-picker__reward-preview img')?.src;
        card.querySelector('.myra-picker__reward-preview')?.remove();
        card.classList.toggle('has-no-preview', !previewSource);
        if (previewSource) {
          const preview = document.createElement('div');
          const image = document.createElement('img');
          preview.className = 'myra-picker__reward-preview';
          image.src = previewSource;
          image.alt = '';
          image.loading = 'lazy';
          preview.append(image);
          card.prepend(preview);
        }
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        details.className = 'myra-luxe__tier-details';
        details.open = openTiers.has(key);
        summary.textContent = title;
        details.append(summary);
        if (description.textContent.trim()) details.append(description);
        details.addEventListener('toggle', () => {
          if (!details.isConnected) return;
          if (details.open) openTiers.add(key);
          else openTiers.delete(key);
          root.dispatchEvent(new CustomEvent('myra:pwyw:phone-content-resized', {
            bubbles: true,
            detail: { expanded: details.open }
          }));
        });
        body.replaceChildren(details);
      });
      updatePurchase(data);
      paintFooter();
      feedback.update(data);
    },
    destroy() {
      feedback.destroy();
      suggestedBadge.remove();
      ultimateBadge.remove();
      upgradeCopy.remove();
      createdCollector?.remove();
      presetOriginals.forEach(({ button, children }) => button.replaceChildren(...children));
      moves.reverse().forEach(({ node, marker }) => marker.replaceWith(node));
      root.remove();
      footerLabel.remove();
      footerTrust.remove();
      delete phone.dataset.luxeScreen;
      priceError.classList.remove('myra-luxe__purchase-error');
      customHeading.textContent = originalHeading;
      customSubtitle.textContent = originalSubtitle;
      if (originalClaimLabel === null) claim.removeAttribute('aria-label');
      else claim.setAttribute('aria-label', originalClaimLabel);
      input.setAttribute('aria-label', originalInputLabel);
      delete section.dataset.mobileLuxe;
    }
  };
};
window.dispatchEvent(new CustomEvent('myra:pwyw:mobile-luxe-ready'));